@if (!hidden) {
    <ms-teaser [teasers]="teasers" [promotions]="promotions" />
}
